import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
  },

  teamName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize',
    paddingLeft: theme.spacing(1),
    margin: 'auto 0',
  },

  disqualified: {
    color: theme.palette.error.light,
  },

  headerContainer: {
    display: 'grid',
    alignItems: 'center',
    gridTemplateColumns: `${theme.spacing(6)} 1fr`,
  },

  statusContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    minWidth: theme.spacing(10),
  },
}));
